import {priority} from '@priority-software/priority-proto-api/lib';
import {IAlertConditionWithID} from '../../actions/proto/index';
import {getUuid4} from '../../../../utils/getUuid4';

export const addIdToCondition = (
    conditions: priority.netitems.form.IAlertCondition[] = []
): IAlertConditionWithID[] => {
    return conditions.map(item => ({...item, id: getUuid4()}));
};
